import { z } from 'zod';
/** Authored observations in a worked trace, not an executable simulation or learner progress. */
export const learningStepsSchema = z.object({
    title: z.string().trim().min(1).max(160),
    steps: z
        .array(z.object({
        title: z.string().trim().min(1).max(100),
        detail: z.string().trim().min(1).max(600),
        state: z
            .array(z.object({
            label: z.string().trim().min(1).max(80),
            value: z.string().trim().min(1).max(300),
        }))
            .min(1)
            .max(6),
    }))
        .min(3)
        .max(6),
});
